module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/agent-training-center_about_referral_manager.png";